import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import { getRandomUid } from 'utilities/uuid.service';
import Icons from 'assets/Icons';

function RatingStars({ value, handleChange, starProps = {} }) {
  return (
    <>
      <Stack spacing={1}>
        <Rating
          name="half-rating"
          precision={0.5}
          size="large"
          value={value}
          onChange={(event, newValue) => {
            handleChange?.(newValue);
          }}
          {...starProps}
        />
      </Stack>
    </>
  );
}

function CustomStarRatings({ value = 0 }) {
  const total = 5;

  const fullStar = parseInt(value % total);
  const halfStar = value % 1;

  const fullStarLoop = [];

  for (let i = 0; i < fullStar; i++) {
    fullStarLoop.push(i);
  }

  return (
    <>
      {fullStarLoop.map(() => {
        return <Icons.starIcon key={getRandomUid()} />;
      })}
      {halfStar > 0 ? <Icons.starHalfIcon /> : null}
    </>
  );
}

export { CustomStarRatings };
export default RatingStars;
